import { memo } from 'react';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { GreenCircle, GridStyled } from './styles';

const StepInfo = ({ title, stepIndex, description }) => (
  <GridStyled aria-label="step item">
    <GreenCircle>{stepIndex}</GreenCircle>
    <Stack spacing="4px">
      <Text
        aria-label="step title"
        size="xl"
        weight="medium"
      >
        {title}
      </Text>
      <Text
        aria-label="step description"
        color="tertiary"
        size="lg"
      >
        {description}
      </Text>
    </Stack>
  </GridStyled>
);

StepInfo.propTypes = {
  title: PropTypes.string.isRequired,
  stepIndex: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired
};

export default memo(StepInfo);
